import { digestBlobSha256 } from './upload-digest-core';
import { workspaceErrorCopy } from './workspace-errors';

function workerDigest(file: Blob, locale?: string) {
  return new Promise<string>((resolve, reject) => {
    const worker = new Worker(new URL('./upload-digest.worker.js', import.meta.url), {
      type: 'module',
    });
    const finish = (action: () => void) => {
      worker.terminate();
      action();
    };
    worker.onmessage = ({ data }: MessageEvent<{ digest?: string; error?: string }>) =>
      finish(() =>
        data.digest
          ? resolve(data.digest)
          : reject(new Error(data.error ?? workspaceErrorCopy(locale).fileVerification)),
      );
    worker.onerror = () =>
      finish(() => reject(new Error(workspaceErrorCopy(locale).fileVerification)));
    worker.postMessage(file);
  });
}

export const fileSha256 = (file: Blob, locale?: string) =>
  typeof Worker === 'undefined' ? digestBlobSha256(file) : workerDigest(file, locale);
